import React from 'react';

import MasterLayout from '../../components/AppLayout/MasterLayout';
import AttachmentsBreadcrumbs from './AttachmentsBreadcrumbs';
import AttachmentsTable from './AttachmentsTable';

const AttachmentsContent = () => {
	return (
		<MasterLayout isNewMerklistePage={true} customTopBarContent={<AttachmentsBreadcrumbs />}>
			<AttachmentsTable />
		</MasterLayout>
	);
};

export default AttachmentsContent;
